import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  getDiscountPrice,
  getFinalPriceVariation,
} from "../../../helpers/product";
import { connect } from "react-redux";

const MenuCart = ({ cartData, currency, removeFromCart, userData, products }) => {
  let cartTotalPrice = 0;
  const [tot, setTot] = useState(0);
  const [totPortoFranco, setTotPortoFranco] = useState(0);
  const { addToast } = useToasts();
  const isBetaRicambi = global.aziendaID === 4 ? true : false;
  const isLoggedUser =
    userData?.user?.user &&
      (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
      ? true
      : false;
  const clienteVisualizzaPrezzi =
    isLoggedUser && userData?.user?.user?.showPrice
      ? userData?.user?.user?.showPrice === 1
      : false;
  console.log("isBetaRicambi", isBetaRicambi, clienteVisualizzaPrezzi);
  useEffect(() => {
    var totale = 0;
    if (cartData && Array.isArray(cartData) && cartData.length > 0) {
      cartData.forEach((single) => {
        var finalProductPrice = 0;
        if (!single?.variation || single.variation?.length == 0) {
          finalProductPrice = single.price?.toFixed(2);
        } else {
          const discountedPrice = getDiscountPrice(
            single.price,
            single.discount,
            single.pricesco
          );
          finalProductPrice = getFinalPriceVariation(
            single,
            single.selectedProductColor,
            single.selectedProductSize
          )?.toFixed(2);
          const finalDiscountedPrice = (
            discountedPrice * currency.currencyRate
          ).toFixed(2);
        }

        totale += finalProductPrice * single.quantity;
      });
      setTot(totale);
      setTotPortoFranco(global.importoPortoFranco - totale);
    }
  }, [cartData]);
  return (
    <div className="shopping-cart-content">
      {totPortoFranco > 0 ? (
        <p
          style={{
            color: "red",
            fontWeight: "bold",
            backgroundColor: "pink",
            border: "1px red solid",
            borderRadius: "10px",
            padding: "5px",
            display: global.importoPortoFranco > 0 ? "block" : "none",
          }}
        >
          Aggiungi altri {(390.0 - tot).toFixed(2)} € per la spedizione gratuita
        </p>
      ) : (
        <p
          style={{
            color: "red",
            fontWeight: "bold",
            backgroundColor: "pink",
            border: "1px red solid",
            borderRadius: "10px",
            padding: "5px",
            display: global.importoPortoFranco > 0 ? "block" : "none",
          }}
        >
          Complimenti! Hai la spedizione gratuita per questo ordine!
        </p>
      )}
      {cartData && Array.isArray(cartData) && cartData.length > 0 ? (
        <Fragment>
          <ul>
            {cartData.map((single, key) => {
              var finalProductPrice = 0;
              if (!single?.variation || single.variation?.length == 0) {
                finalProductPrice =
                  global.aziendaID == 4
                    ? single.pricesco?.toFixed(2)
                    : single.price?.toFixed(2);
              } else {
                const discountedPrice = getDiscountPrice(
                  single.price,
                  single.discount,
                  single.pricesco
                );
                finalProductPrice = getFinalPriceVariation(
                  single,
                  single.selectedProductColor,
                  single.selectedProductSize
                )?.toFixed(2);
                const finalDiscountedPrice = (
                  discountedPrice * currency.currencyRate
                ).toFixed(2);
              }

              cartTotalPrice += finalProductPrice * single.quantity;
              /*
              discountedPrice != null
                ? (cartTotalPrice += finalDiscountedPrice * single.quantity)
                : (cartTotalPrice += finalProductPrice * single.quantity);
              */
              return (
                <li className="single-shopping-cart" key={key}>
                  <div className="shopping-cart-img">
                    <Link to={process.env.PUBLIC_URL + "/product/" + single.id} disable={global.aziendaID === 3}>
                      <img
                        alt=""
                        //src={global.baseUrlImage + single.variation[0].image[0]}
                        id={"image-prod-" + single.id}
                        src={
                          global.baseUrlImage +
                          (single.variation[0]?.image[0]
                            ? single.variation[0].image[0]
                            : single.image[0])
                        }
                        className="img-fluid"
                        onError={() => {
                          var elms = document.querySelectorAll(
                            "[id='" + "image-prod-" + single.id + "']"
                          );
                          for (var i = 0; i < elms.length; i++) {
                            elms[i].src = global.placeholderImage;
                            elms[i].style.objectFit = "contain";
                          }
                        }}
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      {global.aziendaID == 3 ?
                        <span>
                          {single.sku}{" "}
                        </span> :
                        <Link
                          to={process.env.PUBLIC_URL + "/product/" + single.id}
                        >
                          {single.sku}{" "}
                        </Link>}
                    </h4>

                    <h4>
                      {global.aziendaID == 3 ?
                        <span>
                          {single.name}{" "}
                        </span> :
                        <Link
                          to={process.env.PUBLIC_URL + "/product/" + single.id}
                        >
                          {single.name}{" "}
                        </Link>}
                    </h4>
                    <h6>Qtà: {single.quantity}</h6>
                    {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
                      <span>
                        {currency.currencySymbol + " " + finalProductPrice}
                        {/*discountedPrice !== null
                        ? currency.currencySymbol + ' ' + finalDiscountedPrice
                      : currency.currencySymbol + ' ' + finalProductPrice*/}
                      </span>
                    )}
                    {single.selectedProductColor &&
                      single.selectedProductSize ? (
                      <div className="cart-item-variation">
                        <span>Colore: {single.selectedProductColor}</span>
                        <span>Taglia: {single.selectedProductSize}</span>
                        {global.aziendaID === 3 && single.IDArtSta > 0 && Array.isArray(products) && (
                          <span>
                            Grafica: {products.find((p) => p.id == single.IDArtSta)?.sku}
                          </span>
                        )}
                        {global.aziendaID === 3 && single.IDArtSta > 0 && Array.isArray(products) && (
                          <span>
                            <img src={global.baseUrlImage + products.find((p) => p.id == single.IDArtSta)?.image[0]} style={{ width: "50px", height: "50px", objectFit: "contain" }} />
                          </span>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="shopping-cart-delete">
                    <button onClick={() => removeFromCart(single, addToast)}>
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
          {(isBetaRicambi ? clienteVisualizzaPrezzi : true) && (
            <div className="shopping-cart-total">
              <h4>
                Totale :{" "}
                <span className="shop-total">
                  {currency.currencySymbol + " " + cartTotalPrice.toFixed(2)}
                </span>
              </h4>
            </div>
          )}
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={process.env.PUBLIC_URL + "/cart"}>
              Visualizza Carrello
            </Link>
            <Link
              className="default-btn"
              to={process.env.PUBLIC_URL + "/precheckout"}
            >
              checkout
            </Link>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">Nessun articolo nel carrello</p>
      )}
    </div>
  );
};

MenuCart.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
};
const mapDispatchToProps = (dispatch) => { };
const mapStateToProps = (state, ownProps) => {
  return {
    userData: state.userData,
    products: state.productData.products,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuCart);
